module.exports = __webpack_public_path__ + "static/media/accel.6d273646.jpg";